const USER_ACTIONS = Object.freeze({
    LOGIN: "LOGIN",
    RESET: "RESET",
  });
  
  export default USER_ACTIONS;
  